import { gql } from '@apollo/client';

/**
 * Lightweight queries/subscriptions for Meetings LIVE label and green dots.
 * Kept separate from full list fragments so nav + page headers stay cheap.
 */
export const MEETINGS_LIVE_QUICK_CALLS_QUERY = gql`
  query MeetingsLiveIndicators_LiveQuickCalls(
    $audienceOnly: Boolean
    $limit: Int
  ) {
    listQuickCalls(
      audienceOnly: $audienceOnly
      heartbeat: "LIVE"
      limit: $limit
    ) {
      results {
        id
      }
    }
  }
`;

export const MEETINGS_LIVE_QUICK_MEETS_QUERY = gql`
  query MeetingsLiveIndicators_LiveQuickMeets($audienceOnly: Boolean) {
    listLiveQuickMeets(audienceOnly: $audienceOnly) {
      id
    }
  }
`;

export const MEETINGS_ACTIVE_SCHEDULE_MEETS_QUERY = gql`
  query MeetingsLiveIndicators_ActiveScheduleMeets(
    $audienceOnly: Boolean
    $limit: Int
  ) {
    listQuickMeets(audienceOnly: $audienceOnly, isLive: true, limit: $limit) {
      results {
        id
        status
        startAt
        nextSessionStartAt
        durationMinutes
      }
    }
  }
`;

export const MEETINGS_QUICK_CALL_EVENTS_SUBSCRIPTION = gql`
  subscription MeetingsLiveIndicators_QuickCallEvents($audienceOnly: Boolean) {
    quickCallEvents(audienceOnly: $audienceOnly) {
      eventType
      quickCall {
        id
        status
        heartbeat
      }
    }
  }
`;

export const MEETINGS_QUICK_MEET_EVENTS_SUBSCRIPTION = gql`
  subscription MeetingsLiveIndicators_QuickMeetEvents($audienceOnly: Boolean) {
    quickMeetEvents(audienceOnly: $audienceOnly) {
      eventType
      quickMeet {
        id
        status
      }
    }
  }
`;
